const ApiConfigs = () => ({
  baseUrls: {
    // ? shared
    userInfo: 'api/UserInfo',
  },
});

export {
  ApiConfigs,
};
